import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  fetchSeasonInfo,
  selectSeasonInfoData,
  selectSeasonInfoError,
  selectSeasonInfoLoading,
  AppDispatch
} from '@/shared';

export const useSeasonInfo = (defaultLoading = true) => {
  const dispatch = useDispatch<AppDispatch>(); // Use the AppDispatch type for dispatch
  const data = useSelector(selectSeasonInfoData);
  const loading = useSelector(selectSeasonInfoLoading);
  const error = useSelector(selectSeasonInfoError);

  // Fetch airdrop info on mount and set up refresh every minute
  useEffect(() => {
    if (!data && defaultLoading) {
      dispatch(fetchSeasonInfo());
    }
  }, [dispatch, data]);

  // Manual refresh
  const refresh = () => {
    if (!loading) {
      dispatch(fetchSeasonInfo());
    }
  };

  return { data, loading, error, refresh };
};
